import {Product, ProductData} from "../../model/types";
import {getProductCharacteristics} from "../../lib/getProductCharacteristics";
import {ProductCharacteristicsItem} from "./ProductCharacteristicsItem";
import styles from "./ProductCharacteristics.module.scss";

type Props = {
    product: Product,
    productDataCurrent: ProductData,
    previewLength: number;
}

export const ProductCharacteristics = ({product, productDataCurrent, previewLength}: Props) => {
    const characteristics = getProductCharacteristics(product, productDataCurrent);

    return (
        <div className={styles.container}>
            {characteristics.map(item => (
                <ProductCharacteristicsItem key={item.label} item={item} previewLength={previewLength} />
            ))}
        </div>
    );
}
